import React from 'react';
import './sec5.css'
import FAQs from '../components/common/FAQ';
import { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';



const Sec5 = () => {

const { t, i18n } = useTranslation();
const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';


 const [animate, setAnimate] = useState(false);
    const [wasInView, setWasInView] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const section = document.querySelector('.sec5');

            if (section) {
                const rect = section.getBoundingClientRect();
                const windowHeight = window.innerHeight;

                const isInView = rect.top < windowHeight && rect.bottom > 0;

                if (isInView && !wasInView) {
                    setAnimate(false);
                    setTimeout(() => {
                        setAnimate(true);
                    }, 50);
                    setWasInView(true);
                }

                if (!isInView && wasInView) {
                    setAnimate(false);
                    setWasInView(false);
                }
            }
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [wasInView]);






    return ( 
        <section className={`sec5 ${animate ? 'animate' : ''}`} dir={direction}>
            <article className='container-sec5'>
                <h1 className='header-sec5'>{t('Frequently Asked Questions')}</h1>
                <nav className='container-faqs'>
                    <FAQs title={t('How do I book a ticket?')}
                    answer={t('Choose your event, select your seat, and complete the payment to confirm your booking.')}/>
                     <FAQs title={t('Can I cancel or modify my booking?')}
                       answer={t('Yes, depending on the event policy, you can cancel or update your booking before the event date.')}/>
                    <FAQs title={t('What is the refund policy for cancellations?')}
                    answer={t('Refund eligibility depends on the event organizer and the cancellation timing.')}/>
                     <FAQs title={t('Can I book tickets for multiple people at once?')}
                     answer={t('Yes, you can select multiple seats and book for several attendees in one checkout.')}/>
                     <FAQs title={t('Will I be charged a fee for modifying my booking?')}
                       answer={t('Some events may apply a small modification fee depending on the organizer policy.')}
                     />
                </nav>


            </article>
        </section>
     );
}
 
export default Sec5;